import "core-js/modules/es6.array.map";
import "core-js/modules/es6.object.assign";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import styled from 'styled-components';
import Text from '../Text/Text';
import hideVisually from '../../../theme/shared/hideVisually';
import dropDownIcon from './assets/drop-down-dark-purple.svg';
import alertIcon from './assets/error-alert-icon.png';
var StyledInput = styled.select.withConfig({
  displayName: "SelectField__StyledInput",
  componentId: "vncwwx-0"
})(["background-color:", ";width:100%;font-size:", ";display:block;width:100%;box-sizing:border-box;padding:6px 10px;border-width:1px;border-style:solid;border-color:", ";margin:0;position:relative;-moz-appearance:none;-webkit-appearance:none;border-radius:0px;padding:12px 50px 8px 10px;height:50px;font-weight:300;background:white url(", ") calc(100% - 20px) 18px/20px 20px no-repeat;cursor:pointer;margin-bottom:0;cursor:pointer;appearance:none;box-shadow:border-box;border-radius:0;:focus{border:1px solid ", ";}@media ", "{max-width:290px;}"], function (_ref) {
  var color = _ref.color,
      theme = _ref.theme;
  return color ? theme.color(color) : theme.color('white');
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontSize('m');
}, function (_ref3) {
  var theme = _ref3.theme,
      error = _ref3.error;
  return !error ? theme.color('black') : theme.color('red');
}, dropDownIcon, function (_ref4) {
  var theme = _ref4.theme;
  return theme.color('grey_for_forms');
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.breakpoint('small');
});
var Label = styled.label.withConfig({
  displayName: "SelectField__Label",
  componentId: "vncwwx-1"
})(["display:block;margin-bottom:8px;"]);
var LabelText = styled(Text).withConfig({
  displayName: "SelectField__LabelText",
  componentId: "vncwwx-2"
})(["", ""], function (_ref6) {
  var hideLabel = _ref6.hideLabel;
  return hideLabel && hideVisually;
});
/**
 * Text error component
 */

var ErrorText = styled(Text).withConfig({
  displayName: "SelectField__ErrorText",
  componentId: "vncwwx-3"
})(["display:inline-block;color:", ";font-weight:", ";margin-top:", ";:before{position:relative;content:'';display:inline-block;top:2px;vertical-align:middle;margin-right:6px;background:url(", ") left 0/100% no-repeat;width:18px;height:19px;display:inline-block;vertical-align:top;color:", ";}"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.color('red');
}, function (_ref8) {
  var weight = _ref8.weight;
  return weight;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.fontSize('xxs');
}, alertIcon, function (_ref10) {
  var theme = _ref10.theme;
  return theme.color('red');
});

var Select = function Select(_ref11) {
  var errorMsg = _ref11.errorMsg,
      description = _ref11.description,
      label = _ref11.label,
      options = _ref11.options,
      hideLabel = _ref11.hideLabel,
      rest = _objectWithoutProperties(_ref11, ["errorMsg", "description", "label", "options", "hideLabel"]);

  var error = errorMsg && errorMsg.length > 0;
  return React.createElement(Label, null, React.createElement(LabelText, {
    hideLabel: hideLabel,
    weight: "bold"
  }, label), React.createElement(StyledInput, Object.assign({}, rest, {
    error: error ? 1 : 0
  }), React.createElement("option", {
    disabled: true
  }, description), options.map(function (option) {
    return React.createElement("option", {
      key: option.value,
      value: option.value,
      defaultValue: option.defaultValue
    }, option.displayValue);
  })), error && React.createElement(ErrorText, {
    size: "sm"
  }, errorMsg));
};

Select.defaultProps = {
  hideLabel: false
};
export default Select;